import { render, staticRenderFns } from "./edros.vue?vue&type=template&id=4003fd7a&scoped=true&"
import script from "./edros.vue?vue&type=script&lang=js&"
export * from "./edros.vue?vue&type=script&lang=js&"
import style0 from "./edros.vue?vue&type=style&index=0&id=4003fd7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4003fd7a",
  null
  
)

component.options.__file = "edros.vue"
export default component.exports